import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../../config';
import { DictionaryColumnMapping } from '../../../../../types/dictionary';

interface CreateDictionaryMappingParams {
  dictionaryId: string;
  patternId: string;
  patternName: string;
  searchItemId: string;
  searchItemLabel: string;
  searchCsvColumn: string;
  columnMappings: DictionaryColumnMapping[];
}

export const createDictionaryMapping = async (
  params: CreateDictionaryMappingParams,
): Promise<string> => {
  const mappingsRef = collection(db, 'dictionaries', params.dictionaryId, 'dictionary_mappings');
  const newDocRef = doc(mappingsRef);
  const now = Timestamp.now();

  await setDoc(newDocRef, {
    pattern_id: params.patternId,
    pattern_name: params.patternName,
    search_item_id: params.searchItemId,
    search_item_label: params.searchItemLabel,
    search_csv_column: params.searchCsvColumn,
    column_mappings: params.columnMappings,
    created_at: now,
    updated_at: now,
  });

  return newDocRef.id;
};
